export default "__VITE_ASSET__BNaVqc9$__"